

import './App.css'
// import Button from '@mui/material/Button';
import MainContent from './component/MainContent';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';


function App() {
  return (
    <>
        <div style={{display: "flex" , flexWrap:"wrap",  justifyContent:"center" , width:"100vw"}}>
            <Container maxWidth="xl" > 
                <MainContent />
            </Container>
        </div>
    </>

  );
}

export default App;


